import { Box, Button, Container, Grid, Link, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import React from 'react';
import { BasicPage } from '../../../shared/components/BasicPage';
import { HomeContext } from '../../Home/HomeContext';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { AuthContext } from '../../Authentication/AuthContext';
import FAQ from '../../../assets/Clients/Ambev/faq.pdf';
import InfluencerWelcomeMessage from './InfluencerWelcomeMessage';
export default function InfluencerHomeItens(){
        const classes = useInputStyles();
        const homeContext = React.useContext(HomeContext);
        const authContext = React.useContext(AuthContext);
        const profileDescription = authContext.login.user.profile?.description || 'default';
        const profileFuncionalitiesFirst = authContext.login.user.profile?.functionalities[0].description || 'default';
        const userFunctionalitiesList = authContext.login.user.profile?.functionalities.map(f => f.description) || [];
        

    return(
            <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="80vh"
            padding={5}
        >
            <Grid
                direction="column"
                justifyContent="center"
                alignItems="center"
            >
                <Typography variant="h4" className={classes.title}>
                    Bem-vindo à plataforma de Análise de Figuras Públicas da Ambev!
                </Typography>
                <Typography variant="body1" className={classes.item}>
                    Aqui você pode consultar e submeter perfis de figuras públicas à análise de riscos.
                </Typography>
                <Grid container justifyContent="center" alignContent='center' direction='row' spacing={3}>
                    {(authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Cadastro de influencers') != undefined
                        &&
                        authContext.login.user.profile?.functionalities.findIndex(f => f.description == 'Cadastro de influencers') >= 0)
                        && (
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={() => homeContext.setPageLocation(PageLocation.INFLUENCER_UPLOAD)}>
                                    <Box height={30} width={240} fontSize="small">
                                        <div className={classes.alignItemTextCenter}>
                                            Submissão de Novo(s) Perfil(is)
                                        </div>
                                    </Box>
                                </Button>
                            </Grid>
                        )}
                    {(authContext.login.user.profile?.functionalities.findIndex(
                        f => f.description == 'Acesso ao Dash Influencers') != undefined
                    &&
                    authContext.login.user.profile?.functionalities.findIndex(
                        f => f.description == 'Acesso ao Dash Influencers') >= 0)
                    && (
                        <Grid item xs>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth
                                onClick={() => homeContext.setPageLocation(PageLocation.DASHBOARD_INFLUENCER)}>
                                <Box height={30} width={240}>
                                    <div className={classes.alignItemTextCenter}>
                                        Dashboard
                                    </div>
                                </Box>
                            </Button>
                        </Grid>
                    )}
                        {(authContext.login.user.profile?.functionalities.findIndex(
                            f => f.description == 'Cadastro de influencers' || 
                            f.description == 'Classificação de influencers'
                        ) != undefined
                        &&
                        authContext.login.user.profile?.functionalities.findIndex(
                            f => f.description == 'Cadastro de influencers' || 
                            f.description == 'Classificação de influencers'  
                        ) >= 0)

                        && (
                            <Grid item xs>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth>
                                    <Box height={30} width={240}>
                                        <div className={classes.alignItemTextCenter}
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = FAQ;
                                            link.target = '_blank';
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                        }}
                                        >
                                            FAQ
                                        </div>
                                    </Box>
                                </Button>
                            </Grid>
                        )}
                </Grid>
            </Grid>
        </Box>
    );
}